import { allGenericWorksheetModuleTypes } from "@arbeidsark/shared"
import type { WorksheetGenericLanguageModuleType } from "@arbeidsark/shared"
import type { SelectOption } from "~/components"
import CheckSelectMultiple, {
  type CheckSelectMultipleProps,
} from "~/components/Select/CheckSelectMultiple"
import { useTranslate } from "~/ur-react-hooks"

export interface NorwegianTaskTypesMultiSelectProps
  extends Omit<
    CheckSelectMultipleProps<WorksheetGenericLanguageModuleType>,
    "options"
  > {}

const NorwegianTaskTypesMultiSelect: React.FC<
  NorwegianTaskTypesMultiSelectProps
> = ({ ...props }) => {
  const translations = useTranslate({
    "generic/wordSearch": "worksheets.task-types.generic.wordSearch",
    "generic/crossword": "worksheets.task-types.generic.crossword",
    "generic/readingTexts": "worksheets.task-types.generic.readingTexts",
    random: "worksheets.labels.random",
  })

  const options: SelectOption<WorksheetGenericLanguageModuleType>[] =
    allGenericWorksheetModuleTypes.map((type) => ({
      value: type,
      label: translations[type],
    }))

  return <CheckSelectMultiple {...props} options={options} />
}

export default NorwegianTaskTypesMultiSelect
